
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import CarsGallery from './components/CarsGallery';
import VideosGallery from './components/VideosGallery';
import TestimonialsSection from './components/TestimonialsSection';
import StatisticsSection from './components/StatisticsSection';
import GoldenGuaranteeSection from './components/GoldenGuaranteeSection';
import CTASection from './components/CTASection';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <CarsGallery />
      <VideosGallery />
      <TestimonialsSection />
      <StatisticsSection />
      <GoldenGuaranteeSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;
